'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FadeInContent = void 0;
const $ = require("jquery");
const gsap_1 = require("gsap");
const ScrollTrigger_1 = require("gsap/ScrollTrigger");
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
class FadeInContent {
    constructor() {
        // 文字を左からふわっと表示
        if ($('.paramFadeInFromLeft').length) {
            gsap_1.gsap.set(".paramFadeInFromLeft", {
                width: 0,
            });
            ScrollTrigger_1.ScrollTrigger.batch(".paramFadeInFromLeft", {
                onEnter: (batch) => gsap_1.gsap.to(batch, {
                    duration: 3,
                    width: "100%",
                }),
                start: "center bottom",
            });
        }
        // 文字を左からふわっと表示（速バージョン）
        if ($('.paramFadeInFromLeftFast').length) {
            gsap_1.gsap.set(".paramFadeInFromLeftFast", {
                width: 0,
            });
            ScrollTrigger_1.ScrollTrigger.batch(".paramFadeInFromLeftFast", {
                onEnter: (batch) => gsap_1.gsap.to(batch, {
                    duration: 0.5,
                    width: "100%",
                }),
                start: "center bottom",
            });
        }
        // 文字を上からフワッと表示
        if ($('.paramFadeInFromTop').length) {
            gsap_1.gsap.set(".paramFadeInFromTop", {
                height: 0,
            });
            ScrollTrigger_1.ScrollTrigger.batch(".paramFadeInFromTop", {
                onEnter: (batch) => gsap_1.gsap.to(batch, {
                    duration: 1.5,
                    height: "100%",
                }),
                start: "top bottom",
            });
        }
    }
}
exports.FadeInContent = FadeInContent;
exports.default = FadeInContent;
